import Header from "components/Common/Header/Header";
import TreatmentTemplateListBody from "components/AdministrationComponents/TreatmentTemplateComponents/TreatmentTemplateListBody";
import React, { useEffect } from "react";

const TreatmentTemplateList = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Treatment Template";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="treatmenttemplate" />

      <TreatmentTemplateListBody />
    </main>
  );
};

export default TreatmentTemplateList;
